module.exports = __webpack_public_path__ + "img/far_day_cyl75_axis90.04be29f4.jpg";